export const boardChatTour = {
  key: "boardChat",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-chat-minimize"]',
      content: t("Tour_BoardChat_Minimize"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-chat-full"]',
      content: t("Tour_BoardChat_Full"),
      placement: "top",
    },
    {
      target: '[data-tour="board-chat-reply"]',
      content: t("Tour_BoardChat_Reply"),
      placement: "right",
    },
    {
      target: '[data-tour="board-chat-file"]',
      content: t("Tour_BoardChat_File"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-chat-reactions"]',
      content: t("Tour_BoardChat_Reactions"),
      placement: "right",
    },
  ],
};
